export type CurrentWorkItem = {
  id: string;
  org: string;
  role?: string;
  title: string;
  summary: string;
  /** "questions" rotates prompts; "cycle" steps through the sprint loop; "flow" shows data moving between systems */
  visual: "questions" | "cycle" | "flow";
  label: string;
  items: string[];
};

export const currentWork: CurrentWorkItem[] = [
  {
    id: "ai-governance",
    org: "Lawrence University",
    role: "Co-chair",
    title: "AI Governance Council",
    summary: "Building a shared, human-centered way to decide where AI belongs — before the rules exist.",
    visual: "questions",
    label: "Asking first",
    items: [
      "Does AI need to be part of the solution?",
      "Who will experience it?",
      "Where does human judgment need to remain?",
      "What would make us stop?",
    ],
  },
  {
    id: "gdd-sprint-2",
    org: "Lawrence.edu",
    role: "Web product lead",
    title: "Growth-Driven Design, Sprint 2",
    summary: "Turning real post-launch behavior into the next focused release.",
    visual: "cycle",
    label: "The loop",
    items: ["Observe", "Prioritize", "Improve", "Measure"],
  },
  {
    id: "ga4-mcp",
    org: "Analytics + AI",
    role: "Builder",
    title: "A GA4 → Claude MCP",
    summary: "Connecting Google Analytics 4 to Claude so timely reporting takes a question, not a day.",
    visual: "flow",
    label: "The connection",
    items: ["GA4", "MCP", "Claude"],
  },
];
